import { onBeforeUnmount } from 'vue'

/**
 * Samples something that moves over a transition once per animation frame, for
 * a short tail rather than a single read, or every frame for the life of the
 * page. Drives the sticky offsets (useStickyTop).
 *
 * @param {() => boolean} sample reads the page; returns true when what it read
 *   changed, which means the move is still in flight: the tail then runs for
 *   another `settleFrames`
 * @param {number} settleFrames how long the tail runs after the last change
 * @returns {{ schedule: (frames?: number) => void }} starts the tail, or makes
 *   the running one at least `frames` long. The pending frame is cancelled on
 *   unmount.
 */
export function useFrameSampler(sample, settleFrames) {
  let frame = null
  let remainingFrames = 0

  const tick = () => {
    if (sample()) remainingFrames = settleFrames
    remainingFrames -= 1
    frame = remainingFrames >= 0 ? requestAnimationFrame(tick) : null
  }

  const schedule = (frames = settleFrames) => {
    remainingFrames = Math.max(remainingFrames, frames)
    if (frame === null) frame = requestAnimationFrame(tick)
  }

  onBeforeUnmount(() => {
    if (frame !== null) cancelAnimationFrame(frame)
  })

  return { schedule }
}
